import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AlertComponent from '@material-ui/lab/Alert';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import AlertTitle from '@material-ui/lab/AlertTitle';
import Collapse from '@material-ui/core/Collapse';
import classnames from 'classnames';
import { OutlinedButton } from '../Buttons';

const renderActions = (actions = [], theme) => actions.map(
    ({ text, onClick, trackingPayload, testId }) => (
        <OutlinedButton
            onClick={ onClick }
            className={ theme.actionButton }
            text={ text }
            key={ text }
            theme={ theme }
            trackingPayload={ trackingPayload }
            TouchRippleProps={{
                classes: {
                    child: theme.rippleChild,
                    rippleVisible: theme.rippleVisible,
                },
            }}
            { ...(testId ? { testId } : {}) }
        />
    )
);

const Alert = ({
    theme,
    className,
    children,
    severity,
    title,
    actions,
    icon,
    closable = false,
    testId,
}) => {
    const [opened, setOpened] = useState(true);
    const onClose = () => {
        setOpened(false);
    };
    return (
        <Collapse in={ opened }>
            <AlertComponent
                className={ classnames(theme.alert, { [className]: !!className }) }
                severity={ severity }
                classes={{
                    icon: theme.icon,
                    message: theme.message,
                    action: theme.closeIcon,
                    standardSuccess: theme.success,
                    standardInfo: theme.info,
                    standardWarning: theme.warning,
                    standardError: theme.error,
                }}
                iconMapping={{
                    info: <InfoIcon />,
                    success: <CheckCircleIcon />,
                    warning: <WarningIcon />,
                    error: <ErrorIcon />,
                }}
                action={ closable && (
                    <IconButton
                        data-testid="closeButton"
                        size="small"
                        onClick={ onClose }
                    >
                        <CloseIcon />
                    </IconButton>
                ) }
                data-testid={ testId }
                { ...(icon ? { icon } : {}) }
            >
                { title && <AlertTitle classes={{ root: theme.title }}>{title}</AlertTitle> }
                { children }
                { actions ? (
                    <div className={ theme.actions }>
                        { renderActions(actions, theme) }
                    </div>
                ) : null }
            </AlertComponent>
        </Collapse>
    );
};

Alert.propTypes = {
    theme: PropTypes.shape({}),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    className: PropTypes.string,
    icon: PropTypes.node,
    severity: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    actions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
        onClick: PropTypes.func.isRequired,
        trackingPayload: PropTypes.shape({}),
    })),
    closable: PropTypes.bool,
    testId: PropTypes.string,
};

export default Alert;
